

const dateService = {
    formatDate: (dateString) => {
      if (!dateString) return 'N/A';
      
      try {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat(navigator.language, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(date);
      } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
      }
    }
  };
  
  export default dateService;